import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import roleActions from "./actions.js";
import {
  DELETE_ROLE,
  GET_ROLES,
  ROLES_EDIT_MODAL_OPEN_AND_FETCH,
  ROLES_VIEW_MODAL_OPEN_AND_FETCH,
  ROLE_EDIT,
  ROLE_SAVE,
} from "./constants";
const {
  getRolesPending,
  getRolesSuccess,
  getRolesFailure,
  saveRolesPending,
  saveRolesSuccess,
  saveRolesFailure,
  editRolesPending,
  editRolesSuccess,
  editRolesFailure,
  rolesModalSetRole,
  deleteRolePending,
  deleteRoleSuccess,
  deleteRoleFailure,
} = roleActions;

//To get roles by userid
export function* getRoles({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(getRolesPending({ isRolesLoading: true }));
  try {
    const { data } = yield call(api(token).get, `/api/roles?all=true`);
    yield put(getRolesSuccess(data));
  } catch (e) {
    yield put(errorAlert("Error while retrieving roles!"));
    yield put(getRolesFailure({ error: e }));
  }
}

export function* saveRole({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(saveRolesPending({ isRoleSaving: true }));
  try {
    const saveResponse = yield call(api(token).post, `/api/roles/add`, payload);
    yield put(successAlert("Role saved successfully!"));
    yield put(saveRolesSuccess({ message: saveResponse.data.message }));
  } catch (error) {
    yield put(
      errorAlert(typeof error === "string" ? error : "Error while saving role!")
    );
    yield put(saveRolesFailure({ error: error }));
  }
}

export function* openRolesViewModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(api(token).get, `/api/roles/${payload}`);
    if (data && data.id) {
      yield put(rolesModalSetRole(data));
    }
  } catch (e) {
    yield put(errorAlert("Error while retrieving role!"));
  }
}

// using a single action to set role for view and edit
export function* openRolesEditModal({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const isViewModalOpen = yield select(
    (state) => state?.RoleReducer?.isViewModalOpen
  );
  const currentRole = yield select((state) => state?.RoleReducer?.currentRole);
  try {
    if (isViewModalOpen) {
      yield put(rolesModalSetRole(currentRole));
    } else {
      const { data } = yield call(api(token).get, `/api/roles/${payload}`);
      if (data && data.id) {
        yield put(rolesModalSetRole(data));
      }
    }
  } catch (e) {
    yield put(errorAlert("Error while retrieving role!"));
  }
}

export function* editRole({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const currentRole = yield select((state) => state?.RoleReducer?.currentRole);
  yield put(editRolesPending({ isRoleSaving: true }));
  try {
    const saveResponse = yield call(
      api(token).post,
      `/api/roles/edit/${currentRole.id}`,
      payload
    );
    yield put(editRolesSuccess({ message: saveResponse.data.message }));
    yield put(successAlert("Role edited successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string" ? error : "Error while editing role!"
      )
    );
    yield put(editRolesFailure({ error: error }));
  }
}

export function* deleteRole({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  yield put(deleteRolePending({ isRoleDeleting: true }));
  try {
    const deleteResponse = yield call(
      api(token).delete,
      `api/roles/${payload}`
    );
    yield put(deleteRoleSuccess({ message: deleteResponse.data.message }));
    yield put(successAlert("Item deleted successfully!"));
  } catch (error) {
    yield put(
      errorAlert(
        typeof error === "string" ? error : "Error while deleting item!"
      )
    );
    yield put(deleteRoleFailure({ error: error }));
  }
}
export function* watchLoadRoles() {
  yield takeEvery(GET_ROLES, getRoles);
}

export function* watchSaveRole() {
  yield takeEvery(ROLE_SAVE, saveRole);
}

export function* openRolesViewModalFlow() {
  yield takeEvery(ROLES_VIEW_MODAL_OPEN_AND_FETCH, openRolesViewModal);
}

export function* openRolesEditModalFlow() {
  yield takeEvery(ROLES_EDIT_MODAL_OPEN_AND_FETCH, openRolesEditModal);
}

export function* watchEdirRole() {
  yield takeEvery(ROLE_EDIT, editRole);
}

export function* watchDeleteRole() {
  yield takeEvery(DELETE_ROLE, deleteRole);
}

export default function* rolesSaga() {
  yield all([
    watchLoadRoles(),
    watchSaveRole(),
    openRolesViewModalFlow(),
    openRolesEditModalFlow(),
    watchEdirRole(),
    watchDeleteRole(),
  ]);
}
